<template>
    <div class="container flex flex-direction">
        <a :href="`/digitize/all${xiangmu_id ? `?xiangmu_id=${xiangmu_id}` : ''}`" style="position: fixed;top: 20px;left: 20px;width: 150px;height: 40px;text-align: center;line-height: 40px;background: rgba(255,255,255,.2);color: #fff;font-size: 20px;border-radius: 10px;">返回</a>
        <dv-loading v-if="loading" class="loading">Loading...</dv-loading>
        <div class="page-title self-center">首华·双暖为老志愿服务排名</div>
        <div class="flex-sub flex justify-center margin-top-xl padding-lr-sm">
            <dv-border-box-10 :color="['#fa9d1b','yellow']" backgroundColor="transparent" class="title-container">
                <div class="bg-title">
                    <div class="title">队伍排名</div>
                </div>
                <div class="red flex flex-direction padding" style="height: 900px">
                    <div class="flex align-center margin-top">
                        <el-input v-model="keyword1" placeholder="请输入">
                            <i slot="suffix" class="el-input__icon el-icon-search cursor" @click="init"></i>
                        </el-input>
                        <el-select
                            class="margin-left-xs"
                            v-model="order1"
                            @change="init"
                            placeholder="请选择">
                            <el-option
                                v-for="(item) in sorts"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <el-table
                        class="solid margin-top-xs"
                        v-loading="loading"
                        :data="service_team"
                        height="386"
                        header-row-class-name="table-header"
                        style="width: 100%">
                        <el-table-column label="序号" prop="title" width="80">
                            <template slot-scope="scope">
                                <div class="table-item">
                                    {{ scope.$index + 1 }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="所属服务队" prop="level">
                            <template slot-scope="scope">
                                <div class="table-item">
                                    {{ scope.row.name }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="服务参与" prop="level" width="220px;">
                            <template slot-scope="scope">
                                <div class="table-item">
                                    <div class="total">
                                        <b>积<i style="padding-left: 14px;"></i>分：</b><span>{{ scope.row.integral_total.toFixed(2)
                                        }}</span>分
                                    </div>
                                    <div class="total"><b>金暖宝：</b><span>{{ scope.row.jinnuanbao_total.toFixed(2)
                                        }}</span>个
                                    </div>
                                    <div class="total"><b>银暖宝：</b><span>{{ scope.row.yinnuanbao_total.toFixed(2)
                                        }}</span>个
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </dv-border-box-10>
            <dv-border-box-10 :color="['#fa9d1b','yellow']" backgroundColor="transparent"
                              class="title-container margin-lr-sm">
                <div class="bg-title">
                    <div class="title">物业队员排名</div>
                </div>
                <div class="red flex flex-direction padding" style="height: 900px">
                    <div class="flex align-center margin-top">
                        <el-input v-model="keyword2" placeholder="请输入">
                            <i slot="suffix" class="el-input__icon el-icon-search cursor" @click="init"></i>
                        </el-input>
                        <el-select
                            @change="init"
                            class="margin-left-xs"
                            v-model="order2"
                            placeholder="请选择">
                            <el-option
                                v-for="(item) in sorts"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <el-table
                        class="solid margin-top-xs"
                        v-loading="loading"
                        :data="wuye_member"
                        height="386"
                        header-row-class-name="table-header"
                        style="width: 100%">
                        <el-table-column label="序号" prop="title" width="80">
                            <template slot-scope="scope">
                                <div class="table-item">
                                    {{ scope.$index + 1 }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="姓名" prop="name" width="90px">
                            <template slot-scope="scope">
                                <div class="table-item">
                                    {{ scope.row.name }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="所属服务队" prop="team_name">
                            <template slot-scope="scope">
                                <div class="table-item">
                                    {{ scope.row.team_name }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="服务参与" prop="level" width="220px;">
                            <template slot-scope="scope">
                                <div class="table-item">
                                    <div class="total">
                                        <b>积<i style="padding-left: 14px;"></i>分：</b><span>{{ scope.row.integral.toFixed(2)
                                        }}</span>分
                                    </div>
                                    <div class="total"><b>金暖宝：</b><span>{{ scope.row.jinnuanbao.toFixed(2) }}</span>个
                                    </div>
                                    <div class="total"><b>银暖宝：</b><span>{{ scope.row.yinnuanbao.toFixed(2) }}</span>个
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </dv-border-box-10>
            <dv-border-box-10 :color="['#fa9d1b','yellow']" backgroundColor="transparent" class="title-container">
                <div class="bg-title">
                    <div class="title">居民队员排名</div>
                </div>
                <div class="red flex flex-direction padding" style="height: 900px">
                    <div class="flex align-center margin-top">
                        <el-input v-model="keyword3" placeholder="请输入">
                            <i slot="suffix" class="el-input__icon el-icon-search cursor" @click="init"></i>
                        </el-input>
                        <el-select
                            @change="init"
                            class="margin-left-xs"
                            v-model="order3"
                            placeholder="请选择">
                            <el-option
                                v-for="(item) in sorts"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <el-table
                        class="solid margin-top-xs"
                        v-loading="loading"
                        :data="jumin_member"
                        height="386"
                        header-row-class-name="table-header"
                        style="width: 100%">
                        <el-table-column label="序号" prop="title" width="80">
                            <template slot-scope="scope">
                                <div class="table-item">
                                    {{ scope.$index + 1 }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="姓名" prop="name" width="90px">
                            <template slot-scope="scope">
                                <div class="table-item">
                                    {{ scope.row.name }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="所属服务队" prop="team_name">
                            <template slot-scope="scope">
                                <div class="table-item">
                                    <p v-for="(item,index) in scope.row.service_team" :key="index">
                                        {{ item.team_name }}
                                    </p>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="服务参与" prop="level" width="220px;">
                            <template slot-scope="scope">
                                <div class="table-item">
                                    <div class="total">
                                        <b>积<i style="padding-left: 14px;"></i>分：</b><span>{{ scope.row.integral.toFixed(2)
                                        }}</span>分
                                    </div>
                                    <div class="total"><b>金暖宝：</b><span>{{ scope.row.jinnuanbao.toFixed(2) }}</span>个
                                    </div>
                                    <div class="total"><b>银暖宝：</b><span>{{ scope.row.yinnuanbao.toFixed(2) }}</span>个
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </dv-border-box-10>
        </div>
    </div>
</template>

<script>
import {zhiyuanServiceRanking} from "@/api/weilao";
import {sortsList} from "@/utils/utils";

export default {
    name: "service_rank.vue",
    components: {},
    data() {
        return {
            xiangmu_id:'',
            keyword1: '',     //	服务队名称
            order1: 0,	      //  0默认排序 1积分正序 2积分倒序 3金暖宝正序 4金暖宝倒序 5银暖宝正序 6银暖宝倒序
            keyword2: '',    //  物业管家名称
            order2: 0,	  	 //    0默认排序 1积分正序 2积分倒序 3金暖宝正序 4金暖宝倒序 5银暖宝正序 6银暖宝倒序
            keyword3: '',	   //    关键字 服务队员名称
            order3: 0,	     //  0默认排序 1积分正序 2积分倒序 3金暖宝正序 4金暖宝倒序 5银暖宝正序 6银暖宝倒序
            search_content: '',
            service_team: [],
            wuye_member: [],
            jumin_member: [],
            loading: false,
            sorts: sortsList,
        }
    },
    mounted() {
        this.xiangmu_id = this.$route.query.xiangmu_id
        this.init()
    },
    methods: {
        async init() {
            const res = await zhiyuanServiceRanking(
                this.keyword1,
                this.order1,
                this.keyword2,
                this.order2,
                this.keyword3,
                this.order3,
                this.xiangmu_id,
            )
            this.service_team = res.data.service_team
            this.wuye_member = res.data.wuye_member
            this.jumin_member = res.data.jumin_member
        },


    }
}
</script>

<style lang="scss" scoped>
.container {
    background: url(../../../assets/img/data/bg_data.jpg) no-repeat top;
    background-size: 100% 100%;
    height: 1080px;
    width: 1920px;
    overflow: hidden;
    padding: 0 35px 30px;

    .loading {
        color: #ffffff;
        position: fixed;
    }

    .page-title {
        font-size: 36px;
        line-height: 36px;
        color: transparent;
        -webkit-background-clip: text;
        background-image: linear-gradient(0deg,
            #ffd800 0%,
            #ffec83 50%,
            #ffffff 100%);
        background-blend-mode: normal, normal;
        margin-top: 25px;
        font-weight: bold;
    }

    .total-container {
        height: 148px;
        background-image: linear-gradient(270deg,
            #c83e09 10%,
            #e57d1c 50%,
            #e57d1c 100%);
        border: solid 1px #e57a1b;

        &.member {
            background-image: linear-gradient(0deg,
                #c83e09 0%,
                #e57d1c 100%);
        }

        .icon {
            height: 128px;
        }

        .label {
            font-size: 18px;
            color: #ffffff;
        }

        .total {

            font-size: 30px;
            font-weight: bold;
            color: #ffffff;


        }

        .info {
            min-width: 144px;
            padding: 0 12px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background-color: #97371766;
            border-radius: 15px;
            font-size: 18px;
            color: #ffffff;
        }
    }

    .title-container {
        .border-box-content {
            position: relative;
        }

        .years {
            position: absolute;
            right: 20px;
            top: 50px;
            width: 96px;
            height: 26px;
            line-height: 26px;
            border-radius: 15px;
            border: solid 1px #ffffff;
            text-align: center;
            color: #FFFFFF;
        }

        .bg-title {
            z-index: 99;
            width: 556px;
            text-align: center;
            height: 44px;
            line-height: 44px;
            position: absolute;
            background: url(../../../assets/img/data/bg_title.png) no-repeat top;
            background-size: 100% auto;
            left: 50%;
            transform: translateX(-50%);

        }

        .title {
            line-height: 44px;
            font-size: 24px;
            text-align: center;
            color: transparent;
            -webkit-background-clip: text;
            background-image: linear-gradient(0deg,
                #ffd800 0%,
                #ffec83 50%,
                #ffffff 100%);
            background-blend-mode: normal, normal;
            font-weight: bold;
        }
    }

    .table-item {
        .total {
            display: flex;
            align-items: center;
            font-size: 16px;
            color: #ffffff;

            b {
                width: 80px;
                font-weight: normal;
            }

            span {
                width: 80px;
                color: #ffd800;
                font-weight: bold;
            }
        }
    }

    .echarts {
        width: 100%;
        height: 100%;
        background: transparent;
    }

    .map {
        background: url(../../../assets/img/data/bg_map.png) no-repeat top;
        background-size: 100% 100%;
    }

    .dv-border-box-10 {
        background: #b73d0f;
        box-shadow: #fa9d1b55 0px 0px 0px 1px inset !important;
    }

    .swiper-button-prev:after, .swiper-button-next:after {
        color: #fff;
        font-size: 16px;
        width: 13px;
        height: 29px;
        line-height: 29px;
        text-align: center;
        background-color: #d7570e;
    }
}
</style>
